import { DependencyList, useEffect, useState } from 'react';

export const useFooterVisibility = (threshold = 0, deps: DependencyList = []) => {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const handleScrollAndResize = () => {
      const footer = document.getElementById('footer');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const isFooterInView = footerRect.top <= windowHeight - threshold && footerRect.bottom >= 0;
        setIsFooterVisible(isFooterInView);
      }
    };
    handleScrollAndResize(); // Call it immediately to set the initial visibility

    window.addEventListener('scroll', handleScrollAndResize);
    window.addEventListener('resize', handleScrollAndResize);

    return () => {
      window.removeEventListener('scroll', handleScrollAndResize);
      window.removeEventListener('resize', handleScrollAndResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threshold, ...deps]);

  return isFooterVisible;
};
